import { FeatureEnum } from "@smartrr/shared/entities/AccountPlan";
import { useSmartrrFlags } from "@smartrr/shared/LaunchDarkly";
import { Navigate, createLazyFileRoute } from "@tanstack/react-router";

import { ErrorBoundary } from "@vendor-app/app/_sharedComponents/ErrorBoundary";
import { AdminChurnPreventionRoute } from "@vendor-app/app/AdminRoute/AdminChurnPreventionRoute";
import { AuthorizedRoute } from "@vendor-app/app/AdminRoute/components/authorization/AuthorizedRoute";

export const Route = createLazyFileRoute("/admin/configure/retention/cancel-reasons")({
  component: Index,
  errorComponent: ({ error, info }) => <ErrorBoundary error={error} info={info} />,
});

function Page() {
  return AuthorizedRoute(FeatureEnum.RETENTION, <AdminChurnPreventionRoute section="cancel" />);
}

function Index() {
  const { retentionSubPages } = useSmartrrFlags();

  if (retentionSubPages !== true) {
    return <Navigate to="/admin/configure/churn-prevention" search={previous => previous} replace />;
  }

  return <Page />;
}
